import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./appointmentCard.module.css";
import { IAppointment } from "../../../types/types";
import {
  filterFuturedAppointments,
  getDuration,
  isInTheNext24Hours,
} from "../../../utils/utils";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useLazyGetTherapistDatesQuery } from "../../../services/api/therapists.api";
import Modal from "../modal/Modal";
import CancelAppointmentConfirmationPopup from "../cancelAppointmentConfirmation_popup/cancelAppointmentConfirmation_popup";
import CloseButton from "../../closeButton/closeButton";
import { useAppSelector } from "../../../services/hooks";
import { userSelector } from "../../../services/selectors/user.selectors";
import { testUserEmail, testUserEmail2 } from "../../../utils/constants";
import {
  useAlternativeAppointmentProgramDateMutation,
  useGetAllAppointmentsInProgramMutation,
  useGetAllOpenTreatmentPlansForUserMutation,
  useLazyGetAppointmentsByUserIdQuery,
} from "../../../services/api/user.api";
import { TCalendarAppointment } from "../../../services/types/user.types";
import AlternativeAppointmentPopup from "../alternativeAppointmentPopup/alternativeAppointmentPopup";

interface IAppointmentCardProps {
  onClose: () => void;
  appointmentData: IAppointment;
}
function AppointmentCard({ onClose, appointmentData }: IAppointmentCardProps) {
  const navigate = useNavigate();
  const [showOptions, setShowOptions] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openAlterNativeAppointmentModal, setOpenAlterNativeAppointmentModal] =
    useState<TCalendarAppointment | null>(null);

  const user = useAppSelector(userSelector);

  const appointmentDate = new Date(
    appointmentData.appointments.appointmentDate
  );

  const isTestUser =
    user?.email?.toLowerCase() === testUserEmail ||
    user?.email?.toLowerCase() === testUserEmail2;

  const [fetchDates] = useLazyGetTherapistDatesQuery();
  const [getAllAppointmentProgram] =
    useGetAllOpenTreatmentPlansForUserMutation();
  const [getAllAppointmentsInProgram] =
    useGetAllAppointmentsInProgramMutation();
  const [alternativeAppointment] =
    useAlternativeAppointmentProgramDateMutation();
  const [getallappointments] = useLazyGetAppointmentsByUserIdQuery();

  const getAlternativeAppointment = () => {
    getAllAppointmentProgram({
      companyId: appointmentData.appointments.companyId,
      UsersGuid: user.guid,
      usersName: user.fullName,
    }).then((res) => {
      if ("data" in res) {
        const treatmentPlan = res.data.find(
          (item) =>
            item.appointmentsProgram.id ===
            appointmentData.appointments.appointmentsProgramsId
        );
        treatmentPlan &&
          getAllAppointmentsInProgram(treatmentPlan?.appointmentsProgram).then(
            (res) => {
              if ("data" in res) {
                const allAppointments = res.data;
                treatmentPlan &&
                  alternativeAppointment({
                    ...treatmentPlan?.appointmentsProgram,
                    dateToDelete: appointmentData.appointments.appointmentDate,
                    deleteType: 2,
                    updateTherapistsUsersId: Number(user.id),
                  })
                    .then((rs) => {
                      if ("data" in rs) {
                        const newDate = rs.data.find(
                          (appointment2) =>
                            !allAppointments.find(
                              (appointment1) =>
                                appointment1.id === appointment2.id
                            )
                        );
                        if (newDate) {
                          setOpenAlterNativeAppointmentModal(newDate);
                        }
                      }
                    })
                    .finally(() => {
                      getallappointments();
                    });
              }
            }
          );
      }
    });
  };

  return openModal ? (
    <Modal
      onClose={() => {
        setOpenModal(false);
        onClose();
      }}
    >
      <CancelAppointmentConfirmationPopup
        appointmentData={appointmentData}
        onClose={() => {
          setOpenModal(false);
          onClose();
        }}
      />
    </Modal>
  ) : openAlterNativeAppointmentModal ? (
    <Modal
      onClose={() => {
        setOpenModal(false);
        onClose();
      }}
    >
      <AlternativeAppointmentPopup
        appointmentData={openAlterNativeAppointmentModal}
        onClose={() => {
          setOpenModal(false);
          onClose();
        }}
      />
    </Modal>
  ) : (
    <article className={popupStyles.popup}>
      <CloseButton onClick={onClose} />
      <h2 className={popupStyles.popup__title}>{t('APPOINTMENT_DETAILS')}</h2>
      <p className={popupStyles.popup__text}>{t('THERAPIST_NAME')}</p>
      <p className={popupStyles.popup__text_big}>
        {appointmentData.therapistName}
      </p>
      <p className={popupStyles.popup__text}>{t('APPOINTMENT_DATE')}</p>
      <p className={popupStyles.popup__text_big}>
        {`${appointmentDate.getDate()}/${
          appointmentDate.getMonth() + 1
        }/${appointmentDate.getFullYear()}`}
      </p>
      <p className={popupStyles.popup__text}>{t('APPOINTMENT_TIME')}</p>
      <p className={popupStyles.popup__text_big}>
        {(appointmentData.appointments?.startTime && appointmentData.appointments?.endTime)?getDuration(
          appointmentDate,
          appointmentData.appointments.startTime,
          appointmentData.appointments?.endTime
        ):  t('NO_INFORMATION') }
      </p>
      <p className={popupStyles.popup__text}>{t('APPOINTMENT_TYPE')}</p>
      <p className={popupStyles.popup__text_big}>
        {appointmentData.appointments.medias?.name ?? t('NO_INFORMATION')}
      </p>
      <button
        type={"button"}
        className={`${popupStyles.popup__optionsBar} ${
          showOptions && popupStyles.popup__optionsBar_visible
        } ${popupStyles.popup__btn} ${popupStyles.popup__nextBtn}
         ${
           appointmentDate <= new Date() || !isTestUser
             ? popupStyles.popup__btn_disabled
             : "hover"
         } `}
        onClick={() => {
          setShowOptions(!showOptions);
        }}
        disabled={appointmentDate <= new Date() || !isTestUser}
      >
        {t('EDIT_DETAILS')}</button>
      <div
        className={`${popupStyles.popup__optionsBar} ${
          showOptions && popupStyles.popup__optionsBar_visible
        }`}
      >
        <p className={popupStyles.popup__text}>{t('WOULD_YOU_LIKE')}</p>
        <ul className={popupStyles.popup__options}>
          <li>
            <button
              onClick={() => setOpenModal(true)}
              className={`${popupStyles.popup__nextBtn} ${
                popupStyles.popup__optionBtn
              } 
               ${
                 (appointmentDate <= new Date() || !isTestUser) &&
                 popupStyles.popup__btn_disabled
               }`}
              disabled={appointmentDate <= new Date() || !isTestUser}
            >
              {t('CANCEL_APPOINTMENT_ACTION')}</button>
          </li>
          <li>
            <button
              className={`${popupStyles.popup__nextBtn} ${
                popupStyles.popup__optionBtn
              }
                ${
                  (appointmentDate <= new Date() || !isTestUser) &&
                  popupStyles.popup__btn_disabled
                }`}
              disabled={appointmentDate <= new Date() || !isTestUser}
              onClick={() => {
                fetchDates(
                  appointmentData.appointments.therapistsId.toString()
                );
                navigate("search", {
                  replace: true,
                  state: { appointmentData },
                });
              }}
            >
              {t('CHANGE_APPOINTMENT')}</button>
          </li>
        </ul>
      </div>
      {appointmentData.appointments.active &&
        [0, 1, 2].includes(appointmentData.appointments.mediaId) && (
          <button
            type={"button"}
            className={`${popupStyles.popup__btn} button 
          ${
            !isInTheNext24Hours(appointmentData)
              ? popupStyles.popup__btn_disabled
              : "hover"
          }`}
            disabled={!isInTheNext24Hours(appointmentData)}
            onClick={() => {
              navigate("/chat");
            }}
          >
            {t('JOIN_APPOINTMENT')}{" "}
          </button>
        )}
      <button
        type={"button"}
        className={`${popupStyles.popup__btn} button 
          ${
            isInTheNext24Hours(appointmentData)
              ? popupStyles.popup__btn_disabled
              : "hover"
          }`}
        disabled={isInTheNext24Hours(appointmentData) ? true : false}
        onClick={() => {
          getAlternativeAppointment();
        }}
      >
        {t('RESCHEDULE_APPOINTMENT')}</button>
      <button
        type={"button"}
        className={` ${popupStyles.popup__btn} button ${popupStyles.popup__cancelBtn}
         ${
           !filterFuturedAppointments([appointmentData])?.length
             ? popupStyles.popup__btn_disabled
             : "hover"
         } `}
        onClick={() => setOpenModal(true)}
        disabled={
          filterFuturedAppointments([appointmentData])?.length ? false : true
        }
      >
        {t('CANCEL_APPOINTMENT')}</button>
    </article>
  );
}

export default AppointmentCard;
